import { TFunction } from 'i18next';
import { FOLDER_TYPES, FoldersV2 } from 'lib/api/folders/getFoldersV2';
import { FolderOption } from 'lib/components/dropdown/folders/customOption';
import { ALL_FOLDERS_VALUE, SHARED_FOLDER_PREFIX } from 'lib/const/Folders';

export const getFolderName = (option: FolderOption, loggedInUserId: string) => {
  const isDefault = option.folderType === FOLDER_TYPES.DEFAULT;
  const isShared =
    option.folderType === FOLDER_TYPES.SHARED &&
    option.userId?.toString() !== loggedInUserId;
  return isDefault || isShared
    ? `${SHARED_FOLDER_PREFIX}${option.value}`
    : option.value === ALL_FOLDERS_VALUE
      ? option.value
      : option.label.toString();
};

export const mapFolderToOption = (
  folder: FoldersV2,
  userId: string,
  t: TFunction
) => {
  return {
    label:
      folder?.folderType !== FOLDER_TYPES.SHARED
        ? t(folder?.name)
        : folder?.name,
    value: folder.folderId.toString(),
    isSharedFolder:
      folder.userId?.toString() === userId &&
      folder.folderType === FOLDER_TYPES.SHARED,
    sharedBy: folder.sharedBy,
    folderType: folder.folderType,
    userId: folder.userId,
  } as FolderOption;
};
